var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 22C2.25 21.5858 2.58579 21.25 3 21.25H21C21.4142 21.25 21.75 21.5858 21.75 22C21.75 22.4142 21.4142 22.75 21 22.75H3C2.58579 22.75 2.25 22.4142 2.25 22Z",
    fill: "#888B8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 9.38C2.25 8.41579 3.03579 7.63 4 7.63H5.59998C6.56419 7.63 7.34998 8.41579 7.34998 9.38V18C7.34998 18.9642 6.56419 19.75 5.59998 19.75H4C3.03579 19.75 2.25 18.9642 2.25 18V9.38ZM4 9.13C3.86421 9.13 3.75 9.24422 3.75 9.38V18C3.75 18.1358 3.86421 18.25 4 18.25H5.59998C5.73576 18.25 5.84998 18.1358 5.84998 18V9.38C5.84998 9.24422 5.73576 9.13 5.59998 9.13H4Z",
    fill: "#888B8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44922 6.18994C9.44922 5.22573 10.235 4.43994 11.1992 4.43994H12.7992C13.7634 4.43994 14.5492 5.22573 14.5492 6.18994V17.9999C14.5492 18.9642 13.7634 19.7499 12.7992 19.7499H11.1992C10.235 19.7499 9.44922 18.9642 9.44922 17.9999V6.18994ZM11.1992 5.93994C11.0634 5.93994 10.9492 6.05415 10.9492 6.18994V17.9999C10.9492 18.1357 11.0634 18.2499 11.1992 18.2499H12.7992C12.935 18.2499 13.0492 18.1357 13.0492 17.9999V6.18994C13.0492 6.05415 12.935 5.93994 12.7992 5.93994H11.1992Z",
    fill: "#888B8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6504 3C16.6504 2.03579 17.4362 1.25 18.4004 1.25H20.0004C20.9646 1.25 21.7504 2.03579 21.7504 3V18C21.7504 18.9642 20.9646 19.75 20.0004 19.75H18.4004C17.4362 19.75 16.6504 18.9642 16.6504 18V3ZM18.4004 2.75C18.2646 2.75 18.1504 2.86421 18.1504 3V18C18.1504 18.1358 18.2646 18.25 18.4004 18.25H20.0004C20.1362 18.25 20.2504 18.1358 20.2504 18V3C20.2504 2.86421 20.1362 2.75 20.0004 2.75H18.4004Z",
    fill: "#888B8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.f9f51ef37a0ce2ef84c76a86d18f4fde.svg";
export { ForwardRef as ReactComponent };